/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Nav_Resources_ChangelogInputs */

const en_better_studio_nav_resources_changelog = /** @type {(inputs: Better_Studio_Nav_Resources_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Better_Studio_Nav_Resources_ChangelogInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_nav_resources_changelog = /** @type {((inputs?: Better_Studio_Nav_Resources_ChangelogInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Nav_Resources_ChangelogInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_nav_resources_changelog(inputs)
});